import { isRecord } from '../mappers';
import { type AuditMessage, auditMessage } from '../text';
import type { AuditLogEntry } from '../types';
import { AUDIT_REDACTED, auditValueText, toAuditValue } from '../values';

import { firstTwo, SUMMARY_VALUE_LENGTH } from './lines';
import type { AuditSummary } from './types';

function bodyText(field: string, value: unknown, maxLength?: number): AuditMessage {
    return value === AUDIT_REDACTED
        ? auditMessage('auditLog.summary.bodyHidden', { field })
        : auditMessage('auditLog.summary.bodyPair', {
              field,
              value: auditValueText(toAuditValue(value), maxLength),
          });
}

/** Rule 7: the request body the interceptor echoed, or the marker that it was too large. */
export function summarizeRequestEcho(entry: AuditLogEntry): AuditSummary | null {
    const metadata = entry.metadata;
    if (metadata === null) return null;
    if (metadata.truncated === true) {
        const line = auditMessage('auditLog.summary.tooLarge');
        return { rule: 'request', line, title: [line] };
    }
    const body = metadata.body;
    if (!isRecord(body)) return null;
    const fields = Object.keys(body);
    const line = firstTwo(
        fields.map((field) => bodyText(field, body[field], SUMMARY_VALUE_LENGTH))
    );
    if (line === null) return null;
    return { rule: 'request', line, title: fields.map((field) => bodyText(field, body[field])) };
}
